import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgFiles = function SvgFiles(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M22.25 3.854L18.84.441A1.5 1.5 0 0017.776 0H7.19a1.5 1.5 0 00-1.5 1.5V19a1.5 1.5 0 001.5 1.5h14a1.5 1.5 0 001.5-1.5V4.914c0-.398-.157-.78-.44-1.06z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M18.19 22h-13a1 1 0 01-1-1V3.5a1 1 0 10-2 0V21a3 3 0 003 3h13a1 1 0 100-2z"
  }));
};

export default SvgFiles;